import { MuiButton } from '@/components/button/MuiButton';
import { RHFCheckbox } from '@/components/checkbox/RHFCheckbox';
import { api_portalOfficeListing_filter } from '@/init/swagger';
import { SearchPublicHomeType } from '@/schemas/SearchPublicHomeSchema';
import { List, ListItem } from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

const DEFAULT_SHOW_LENGTH = 7;

type Props = {
  filters: api_portalOfficeListing_filter[];
  toggleCheckbox: ({ filtersKey }: { filtersKey: string }) => void;
  disabled?: boolean;
};

export function SearchFilterList({
  filters,
  toggleCheckbox,
  disabled = false,
}: Props) {
  const { control } = useFormContext<SearchPublicHomeType>();

  const [loadIndex, setLoadIndex] = useState(DEFAULT_SHOW_LENGTH);

  const moreShow = () => {
    if (loadIndex === DEFAULT_SHOW_LENGTH) {
      setLoadIndex(filters.length);
    } else {
      setLoadIndex(DEFAULT_SHOW_LENGTH);
    }
  };

  return (
    <>
      <List disablePadding sx={{ width: '100%' }}>
        {filters.slice(0, loadIndex).map((searchFilter) => {
          return (
            <ListItem
              key={`${searchFilter.category_id}_${searchFilter.id}`}
              disablePadding
              sx={{
                mb: -1,
                '& .MuiFormGroup-root': {
                  backgroundColor: 'unset',
                },
              }}
            >
              <RHFCheckbox
                name={`filters.${searchFilter.category_id}_${searchFilter.id}`}
                control={control}
                onChange={() =>
                  toggleCheckbox({
                    filtersKey: `${searchFilter.category_id}_${searchFilter.id}`,
                  })
                }
                label={searchFilter.label}
                disabled={disabled}
                sx={{ pl: 0 }}
              />
            </ListItem>
          );
        })}
      </List>

      {filters.length > DEFAULT_SHOW_LENGTH && (
        <MuiButton
          variant="text"
          onClick={moreShow}
          size="small"
          sx={{ width: 'max-content' }}
        >
          {loadIndex === DEFAULT_SHOW_LENGTH ? 'もっと見る' : '閉じる'}
        </MuiButton>
      )}
    </>
  );
}
